import React from "react";
import { Button, Container } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import "./Blog.css";
import first from "../../../../Asset/blog/1.webp";
import second from "../../../../Asset/blog/2.jpg";
import third from "../../../../Asset/blog/3.webp";
import { useNavigate } from "react-router-dom";

const blogPosts = [
  {
    imgSrc: first,
    title: "GITEX 2023: Impact on UAE’s economy and tech industry",
  },
  {
    imgSrc: second,
    title:
      "Win-Win Collaboration: Why IT Recruiters Should Team Up with Software Consultants",
  },
  {
    imgSrc: third,
    title:
      "Custom Software vs. Ready-Made Solutions: What’s The Perfect Fit for Your Business?",
  },
];

const BlogCard = ({ imgSrc, title }) => (
  <div className="col-lg-4 col-md-4 col-12">
    <div className="blog-card">
      <div className="blog-img-card">
        <img src={imgSrc} className="w-100" alt={title} />
      </div>
      <div className="blog-content">
        <p>{title}</p>
      </div>
    </div>
  </div>
);

const Blog = () => {
  const navigate = useNavigate();
  return (
    <section className="blog-extra-services-section">
      <Container>
        <div className="top-text-third-webDevelopment">
          <h2>
            OUR <span> BLOG </span>
          </h2>
        </div>
        <div className="row service-page-section-6-blog-row">
          {blogPosts.map((post, index) => (
            <BlogCard key={index} imgSrc={post.imgSrc} title={post.title} />
          ))}
        </div>
        <div className="arrow-row">
          <Button
            onClick={() => {
              navigate("/Blog");
            }}
            className="btn btn-primary"
          >
            More from our Blog
            <FaArrowRight className="arrow-icon" />
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default Blog;
